import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import RiderIcons from "../../Icons/RiderIcons";
const RiderInvoiceComponent = loadable(
  () => import("../../components/RiderInvoice/RiderInvoiceList")
);
const RiderInvoice = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <RiderIcons />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Rider Statement List
        </span>
      </div>
      <RiderInvoiceComponent />
    </>
  );
};

export default RiderInvoice;
